import { createFileRoute } from "@tanstack/react-router";
import { JoinPage } from "../features/session/join-page";

export const Route = createFileRoute("/join/")({ component: () => <JoinPage code="" /> });
